import React, { useMemo } from "react";
import "./SapCard.css";

export default function SapCard({ data, onOpen }) {
  const { name = ""} = data || {};

  return (
    <button className="sapCard" onClick={onOpen} title={`Abrir ${name}`}>
      <div className="sapCard-info">
        <div className="sapCard-name">{name}</div>
      </div>
    </button>
  );
}
